//Reset data
export const RESET = "PARAMETRE_UPDATE_RESET"

export const SET_IS_UPDATED = "PARAMETRE_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "PARAMETRE_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "PARAMETRE_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "PARAMETRE_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "PARAMETRE_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "PARAMETRE_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "PARAMETRE_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "PARAMETRE_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "PARAMETRE_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "PARAMETRE_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "PARAMETRE_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "PARAMETRE_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "PARAMETRE_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "PARAMETRE_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "PARAMETRE_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "PARAMETRE_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "PARAMETRE_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "PARAMETRE_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "PARAMETRE_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "PARAMETRE_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "PARAMETRE_UPDATE_SET_MODAL_TYPE"